import { lazy } from 'react';
// @ts-ignore
export const LoginScreenAsync = lazy(() => import('./LoginScreen.tsx'));
